import request from '@/utils/request'

// 获取一周收费数据
export function getWeekFinance(data) {
	return request({
		url: '/index/weekfinance',
		method: 'post',
		data
	})
}

// 获取本周开庭
export function getWeekCourt(data) {
	return request({
		url: '/index/weekcourt',
		method: 'post',
		data
	})
}

// 获取工作台数据
export function getTopData(data) {
	return request({
		url: '/index/gettopdata',
		method: 'post',
		data
	})
}

// 日程列表
export function scheduleList(data) {
	return request({
		url: '/event/index',
		method: 'post',
		data: data
	})
}
// 日程添加
export function scheduleAdd(data) {
	return request({
		url: '/event/save',
		method: 'post',
		data: data
	})
}
// 日程删除
export function scheduleDelete(data) {
	return request({
		url: '/event/delete',
		method: 'post',
		data: data
	})
}
// 日程编辑
export function scheduleEdit(data) {
	return request({
		url: '/event/update',
		method: 'post',
		data: data
	})
}

// 日程
export function scheduleListAPI(data) {
	return request({
		url: '/event/eventlist',
		method: 'post',
		data: data
	})
}

// 日程详情
export function eventList(data) {
	return request({
		url: '/event/indexevent',
		method: 'post',
		data: data
	})
}